import { errorRenderer } from './components/errorRenderer';


export * from './components/ArrayErrorsComponent';
export * from './components/FormField';
export * from './components/CalendarField';
export type { TranslatedCalendarInputProps } from './components/CalendarField';
export * from './components/CheckboxField';
export * from './components/RadioField';
export * from './components/StyledInputField';

export const forms = {
    forms: {
        errorRenderer,
    },
};
